import { Injectable } from '@angular/core';
import { BaseHubConnection } from './base-hub-connection.service'; // BaseHubConnection sınıfının yolu
import { DeviceModel } from './models/device.model';
import { BehaviorSubject } from 'rxjs';
import { GlobalVariablesService } from '../global-variables.service';

export interface ReaderHealthStatusChangedModel {
  readerId: string;
  readerName: string;
  connectionValue: string;
  online: boolean;
  seenAt?: string;
  lastSeenAt?: string;
  offlineSince?: string;
  source?: string;
  timeoutSeconds?: number;
}

@Injectable({
  providedIn: 'root'
})
/**
 * Represents a hub connection service for devices.
 */
export class DeviceHubConnectionService extends BaseHubConnection {
  
  private deviceUpdatedSubject: BehaviorSubject<DeviceModel> = new BehaviorSubject<DeviceModel>(null);
  public deviceUpdated$ = this.deviceUpdatedSubject.asObservable();
  private readerHealthStatusChangedSubject: BehaviorSubject<ReaderHealthStatusChangedModel | null> =
    new BehaviorSubject<ReaderHealthStatusChangedModel | null>(null);
  public readerHealthStatusChanged$ = this.readerHealthStatusChangedSubject.asObservable();

  constructor(private globals: GlobalVariablesService) {
    super();
  
   

  }

  public init() {
    this.initializeHubConnection(this.globals.buildTrackerUrl('/device-hub'), this.webSocketOnlyOptions({ withCredentials: true }));
    this.connectionStatus.subscribe((status) => {
     
    }
    );

    this.hubConnection.on("DeviceUpdated", (data: any) => {
      const device = new DeviceModel(data);
      this.deviceUpdatedSubject.next(device);
    });

    this.hubConnection.on("ReaderStatusChanged", (data: ReaderHealthStatusChangedModel) => {
      this.readerHealthStatusChangedSubject.next(data);
    });
  }
}
